import { cn } from '@/lib/utils';
import type { Tooltip as TooltipPrimitive } from 'radix-ui';
export const CustomArrow = ({
  className,
  ...props
}: TooltipPrimitive.TooltipArrowProps & React.HTMLAttributes<HTMLDivElement>) => <div className={cn('size-3 rotate-45', className)} {...props} data-sentry-component="CustomArrow" data-sentry-source-file="custom-arrow.tsx" />;